import { render } from "./NotaryWaitingList.vue?vue&type=template&id=f884951c&scoped=true"
import script from "./NotaryWaitingList.vue?vue&type=script&lang=js"
export * from "./NotaryWaitingList.vue?vue&type=script&lang=js"

import "./NotaryWaitingList.vue?vue&type=style&index=0&id=f884951c&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f884951c"]])

export default __exports__